import React from 'react';
import {Modal, View, Text, TouchableOpacity, useWindowDimensions} from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';
import i18n from 'i18n-js';
import {fontFamily} from '../../helpers/fontFamily';

const UnsavedChangesPrompt = ({
  visible,
  saving = false,
  title = i18n.t('unsavedChanges.promptTitle'),
  message = i18n.t('unsavedChanges.promptMessage'),
  saveText = i18n.t('unsavedChanges.save'),
  discardText = i18n.t('unsavedChanges.discard'),
  onSave,
  onDiscard,
  onStay
}) => {
  const {width: screenWidth} = useWindowDimensions();
  const modalWidth = Math.min(screenWidth * 0.9, 500);
  const horizontalPadding = screenWidth <= 768 ? 16 : 28;

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onStay}>
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0,0,0,0.5)'
        }}>
        <LinearGradient
          colors={['#FFB538', '#CF7C08']}
          start={{x: 0.5, y: 0}}
          end={{x: 0.5, y: 1}}
          style={{
            paddingVertical: 30,
            paddingHorizontal: horizontalPadding,
            borderRadius: 15,
            alignItems: 'center',
            position: 'relative',
            width: modalWidth
          }}>
          <TouchableOpacity
            testID="unsavedPromptStay"
            onPress={onStay}
            style={{position: 'absolute', top: 10, right: 10, zIndex: 10, padding: 5}}>
            <Text style={{fontSize: 24, color: '#000000', fontWeight: 'bold'}}>×</Text>
          </TouchableOpacity>

          <Text
            style={{
              fontSize: 24,
              marginBottom: 10,
              fontFamily: fontFamily.font300,
              textAlign: 'center',
              color: '#000000'
            }}>
            {title}
          </Text>

          <Text
            style={{
              fontSize: 18,
              marginBottom: 20,
              fontFamily: fontFamily.font300,
              textAlign: 'center',
              color: '#000000'
            }}>
            {message}
          </Text>

          <View style={{flexDirection: 'row', justifyContent: 'space-between', gap: 15}}>
            <TouchableOpacity
              testID="unsavedPromptDiscard"
              style={{
                paddingHorizontal: 10,
                paddingVertical: 3,
                borderRadius: 15,
                minWidth: 100,
                alignItems: 'center',
                borderWidth: 1,
                borderColor: '#000000'
              }}
              disabled={saving}
              onPress={onDiscard}>
              <Text style={{color: '#000000', fontFamily: fontFamily.font300}}>
                {discardText}
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              testID="unsavedPromptSave"
              style={{
                paddingHorizontal: 10,
                paddingVertical: 3,
                borderRadius: 15,
                minWidth: 100,
                alignItems: 'center',
                borderWidth: 1,
                borderColor: '#000000',
                opacity: saving ? 0.6 : 1
              }}
              disabled={saving}
              onPress={onSave}>
              <Text style={{color: '#000000', fontFamily: fontFamily.font300}}>
                {saving ? i18n.t('unsavedChanges.saving') : saveText}
              </Text>
            </TouchableOpacity>
          </View>
        </LinearGradient>
      </View>
    </Modal>
  );
};

export default UnsavedChangesPrompt;
